import MypageAddressContainer from './MypageAddressContainer';
export default MypageAddressContainer;
